module.exports = __webpack_public_path__ + "img/alert_fan.130ee6fb.svg";